import React, { useState } from "react";
import noImg from "../../../Assets/noimage.png";
import "../../../Components/pages/product.css";
import { FaTrash } from "react-icons/fa";
import { Button, Spinner } from "react-bootstrap";
import { getImageUrl, getUrl } from "../../../MIS/Global";
import ToggleSwitch from "../../GlobalComponent/ToggleSwitch";
import axios from "axios";

const SubProductList = ({ data, onEdit, onDelete,isLoading,isError}) => {
  
  const [loadingToggles, setLoadingToggles] = useState({});
  const [currentToggles, setCurrentToggles] = useState({});

  const apiClient = axios.create({
    baseURL: getUrl(),
    headers: { "Content-Type": "application/json" },
  });
  

  const handleStatusUpdate=async(id,status)=>{
    setLoadingToggles((prev) => ({ ...prev, [id]: true }));
    setCurrentToggles((prev) => ({ ...prev, [id]: status }));
    let subp_status=0;    
    if(status===true){
      subp_status=0;
    }else{
      subp_status=1;
    }
    let data={id,subp_status,action:"updateStatus"};    
    try {
      const res = await apiClient.patch("sub-product/", data);
    } catch (error) {
      
    } finally{
      setLoadingToggles((prev) => ({ ...prev, [id]: false })); 
    }
    
  }
  return (
    <>
      <div className="table-responsive auto-fill">
        {isLoading ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "250px" }}
          >
            <Spinner animation="border" />
          </div>
        ) : isError ? (
          <div className="text-danger text-center">Failed to load data.</div>
        ) : data?.length > 0 ? (
          <table className="table table-sm w-100">
            <tbody className="list">
              {data?.map((element, index) => {
                return (
                  <tr key={index} className="product-card" style={{cursor:"pointer"}}>
                    <td className="d-flex align-items-center gap-2" 
                    //  onClick={(e)=>{onEdit(element)}}
                    onClick={(e) => {
                      if (!e.target.closest(".toggle-wrapper")) {  
                        onEdit(element);
                      }
                    }}
                    >
                    {/* {getImageUrl(`/${element?.imgpath}`)} */}
                      <img
                        src={getImageUrl(`${element?.imgpath}`) || noImg}
                        className="rounded"
                        alt="Main Product"
                        style={{ width: "55px", height: "55px",objectFit:"contain" }}
                      />
                      <div className='w-100'>
                        <h6>{element?.subpname}</h6>
                        <div className="d-flex justify-content-between align-items-center w-100">
                          <h6 className="text-muted" style={{fontSize:"14px"}}>{element?.mpname}</h6>
                          <div className="toggle-wrapper"> 
                          {loadingToggles[element.id] ? (
                            <Spinner animation="border" size="sm" variant="primary" />
                          ) : (
                            <ToggleSwitch
                              onChange={(status) => handleStatusUpdate(element.id, status)}
                              initialState={
                                currentToggles.hasOwnProperty(element.id) 
                                  ? currentToggles[element.id] 
                                  : element.subp_status === 0
                                }
                              onLabel="On"
                              offLabel="Off"
                            />
                          )}
                          </div>
                        </div>
                      </div>
                    </td>
                    <Button
                      variant="danger"
                      size="sm"
                      className="delete-icon position-absolute top-0 end-0 m-2 d-flex justify-content-center p-1"
                      //   onClick={onDelete}
                      onClick={(e)=>{onDelete(element?.id)}}
                    >
                      <FaTrash />
                    </Button>
                  </tr>
                );
              })}
            </tbody>
          </table>
        ) : (
          <div className="text-center">No sub-product available.</div>
        )}
      </div>
    </>
  );
};

export default SubProductList;
